import Loader from './lib/Loader';

export default Loader;
